import type { ReactNode } from "react";

export function RevenueField({
  id,
  label,
  hint,
  children,
  fullWidth = false,
}: {
  readonly id: string;
  readonly label: ReactNode;
  readonly hint?: ReactNode;
  readonly children: ReactNode;
  readonly fullWidth?: boolean;
}) {
  return (
    <div className={`revenue-field${fullWidth ? " revenue-field--full" : ""}`}>
      <label htmlFor={id}>{label}</label>
      {children}
      {hint ? (
        <p id={`${id}-hint`} className="revenue-field__hint">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
